import { useEffect } from 'react';

interface SeoOptions {
  description?: string;
  keywords?: string;
}

export function useDocumentTitle(title: string, options: SeoOptions = {}) {
  useEffect(() => {
    document.title = title;

    if (options.description) {
      let desc = document.querySelector('meta[name="description"]');
      if (!desc) {
        desc = document.createElement('meta');
        desc.setAttribute('name', 'description');
        document.head.appendChild(desc);
      }
      desc.setAttribute('content', options.description);
    }

    if (options.keywords) {
      let kw = document.querySelector('meta[name="keywords"]');
      if (!kw) {
        kw = document.createElement('meta');
        kw.setAttribute('name', 'keywords');
        document.head.appendChild(kw);
      }
      kw.setAttribute('content', options.keywords);
    }
  }, [title, options.description, options.keywords]);
}